import { useEffect, useRef } from 'react';
import { useLocation } from 'quartz-routing/react-router';
const useOnNavigation = onNavigation => {
  const location = useLocation();
  const locationRef = useRef(location.pathname);
  useEffect(() => {
    if (locationRef.current !== location.pathname) {
      onNavigation();
      locationRef.current = location.pathname;
    }
  }, [location.pathname, onNavigation]);
};
export default useOnNavigation;